import React, { useState, useRef, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";

import {
  deleteProvinceById,
  fetchProvinceList,
  restoreProvince,
  searchProvinces,
  toggleProvinceStatus,
} from "../../services/axios/apiManager";
import BSPagination from "../../Components/pagination";
import ProvinceFilters from "./provincesFilters";
import ProvinceDetails from "./provinceDetails";
import AddEditProvinceModal from "./addEditProvince";
import { toast } from "sonner";
import { handleErrors } from "../../services/dataManager";
import { useNavigate, useSearchParams } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-bs5";
const ProvinceList = ({
  provinces,
  setProvinces,
  pagination,
  setPagination,
  countriesList,
  granted,
}) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState(searchParams.get("search") || "");
  const [filters, setFilters] = useState(searchParams.get("status") || 3);
  const [filtering, setFiltering] = useState(false);
  const [selectedProvince, setSelectedProvince] = useState({});
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [modalOptions, setModalOptions] = useState({});
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const tableRef = useRef(null);

  ////////////////////////////////////////////////////////////////
  const fetchProvinces = async (pgntn, str = "") => {
    try {
      setFiltering(true);
      const page = pgntn?.currentPage || searchParams.get("page") || 1;
      const pageSize = pgntn?.pageSize || pagination.pageSize || 10;

      // Sync URL if page is different
      if (pgntn?.currentPage && pgntn.currentPage != (searchParams.get("page") || 1)) {
        const params = new URLSearchParams(searchParams);
        params.set("page", pgntn.currentPage);
        setSearchParams(params);
      }

      const res = await fetchProvinceList(page, pageSize, str);
      if (res?.data?.data) {
        setProvinces(res.data.data);
        if (res?.data?.pagination) {
          setPagination(res.data.pagination);
        }
      } else {
        handleErrors(res, navigate, "Province List:");
      }
    } catch (error) {
      handleErrors(error, navigate, "Province List:");
    } finally {
      setFiltering(false);
    }
  };

  useEffect(() => {
    setQuery(searchParams.get("search") || "");
    setFilters(searchParams.get("status") || 3);
  }, [searchParams]);

  const handlePageChange = async (page) => {
    const params = new URLSearchParams(searchParams);
    params.set("page", page);
    setSearchParams(params);
  };

  // // // Close Status/Delete Modal logic
  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };

  // // // Open Status change modal
  const handleStatusChange = async (prov) => {
    if (!granted?.some((g) => g.type === "toggle-status")) {
      toast.error(
        "You don't have neccessary permissions to do this operation!",
        {
          duration: 3000,
        }
      );
      return;
    }
    setModalOptions({
      header: "Change Status",
      body: `Are you sure you want to change the status of Province "${prov?.province_name || ""}"?`,
      okay: "Change",
      method: changeStatus,
      data: { id: prov.id, status: prov.status === 1 ? 0 : 1 },
    });
    setShowOptionsModal(true);
  };

  // // // Change Status logic
  const changeStatus = async (data) => {
    const res = await toggleProvinceStatus(data);
    if (res?.data?.success === true) {
      const str = `status=${filters}`;
      await fetchProvinces(pagination, str);
    } else {
      handleErrors(res, navigate, "Change Status:");
    }
    setModalOptions({});
    setShowOptionsModal(false);
  };

  // // // Delete Province Modal logic
  const handleDeleteProvince = (prov) => {
    setModalOptions({
      header: "Delete Province",
      body: `Are you sure you want to delete Province "${prov?.province_name || ""}"?`,
      okay: "Delete",
      method: deleteProvince,
      data: { id: prov.id },
    });
    setShowOptionsModal(true);
  };

  // // // Delete Province logic
  const deleteProvince = async (data) => {
    if (data.id) {
      const res = await deleteProvinceById(data.id);
      if (res?.data?.success) {
        const str = `status=${filters}`;
        await fetchProvinces(pagination, str);
        toast.info("Province record has been deleted!", {
          duration: 2000,
        });
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        handleErrors(res, navigate, "Delete Province:");
        setModalOptions({});
        setShowOptionsModal(false);
      }
    }
  };

  const handleRestoreProvince = (prov) => {
    setModalOptions({
      header: "Restore Province",
      body: `Are you sure you want to restore Province "${prov?.province_name || ""}"?`,
      okay: "Delete",
      method: restoreProvinceById,
      data: { id: prov.id },
    });
    setShowOptionsModal(true);
  };

  // // // Restore Province logic
  const restoreProvinceById = async (data) => {
    if (data.id) {
      const res = await restoreProvince(data.id);
      if (res?.data?.success) {
        const str = `status=${filters}`;
        await fetchProvinces(pagination, str);
        toast.info("Province record has been restored!", {
          duration: 2000,
        });
        setModalOptions({});
        setShowOptionsModal(false);
      } else {
        handleErrors(res, navigate, "Delete Province:");
        setModalOptions({});
        setShowOptionsModal(false);
      }
    }
  };

  // // // Open Add Edit Modal
  const handleOpenAddEditModal = (prov) => {
    setSelectedProvince(prov);
    setShowAddEditModal(true);
  };
  ////////////////////////////////////////////////////////////////

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = provinces.map((p) => {
      const statusBtn =
        `<button class=\"btn btn-sm status-btn ${p.status === 1 ? "text-success" : "text-danger"}\" data-id=\"${p.id}\" title="change status">` +
        `${p.status === 1 ? "Active" : "Inactive"}</button>`;
      let actions = ``;
      actions +=
        filters !== "2"
          ? `<button class=\"btn btn-sm btn-outline-success view-btn me-1\" data-id=\"${p.id}\" title=\"View detalis\" >` +
            `<i class=\"fas fa-eye\"></i></button>`
          : "";
      if (granted.some((g) => g.type === "update") && filters !== "2") {
        actions +=
          `<button class=\"btn btn-sm btn-outline-primary edit-btn me-1\" data-id=\"${p.id}\" title=\"Edit\" >` +
          `<i class=\"fas fa-edit\"></i></button>`;
      }
      if (
        granted.some((g) => g.type === "delete") &&
        !p.is_associated &&
        p.status === 0 &&
        filters !== "2"
      ) {
        actions +=
          `<button class=\"btn btn-sm btn-outline-danger delete-btn\" data-id=\"${p.id}\" title=\"Delete\">` +
          `<i class=\"fas fa-trash-alt\"></i></button>`;
      }
      if (!p.deleteAt && filters === "2") {
        actions +=
          `<button class=\"btn btn-sm btn-outline-danger restore-btn\" data-id=\"${p.id}\" title=\"restore\">` +
          `<i class="fa-solid fa-rotate-right"></i></button>`;
      }
      return [
        // p.id,
        p.province_name,
        p.province_code,
        p.country?.country_name || "",
        statusBtn,
        actions,
      ];
    });
    const config = {
      data: rows,
      columns: [
        // { title: "ID", className: "text-start" }, // add className here
        { title: "Province Name" },
        { title: "Province Code" },
        { title: "Country" },
        { title: "Status", orderable: false },
        { title: "Actions", orderable: false },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };
    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    // events
    $table.off("click", ".view-btn").on("click", ".view-btn", function () {
      const id = $(this).data("id");
      setSelectedProvince(provinces.find((x) => x.id === id));
      setOpenDetailsModal(true);
    });
    $table.off("click", ".edit-btn").on("click", ".edit-btn", function () {
      const id = $(this).data("id");
      const prov = provinces.find((x) => x.id === id);
      setSelectedProvince(prov);
      setShowAddEditModal(true);
    });
    $table.off("click", ".status-btn").on("click", ".status-btn", function () {
      const id = $(this).data("id");
      const prov = provinces.find((x) => x.id === id);
      if (!prov?.deletedAt) {
        handleStatusChange(prov);
      } else {
        toast.info("Cannot change status of a deleted record!", {
          duration: 2000,
        });
      }
    });
    $table.off("click", ".delete-btn").on("click", ".delete-btn", function () {
      const id = $(this).data("id");
      const prov = provinces.find((x) => x.id === id);
      handleDeleteProvince(prov);
    });
    $table
      .off("click", ".restore-btn")
      .on("click", ".restore-btn", function () {
        const id = $(this).data("id");
        const prov = provinces.find((x) => x.id === id);
        handleRestoreProvince(prov);
      });
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current))
        $table.DataTable().destroy();
    };
  }, [provinces, granted]);
  return (
    <div className="container">
      <div className="bg-dark p-4 rounded mb-4">
        <div className="row mb-2">
          <ProvinceFilters
            pagination={pagination}
            setPagination={setPagination}
            query={query}
            setQuery={setQuery}
            filters={filters}
            setFilters={setFilters}
            setProvinces={setProvinces}
            fetchProvinces={fetchProvinces}
            filtering={filtering}
            setFiltering={setFiltering}
          />
          <div className="col-md-2">
            {granted?.some((g) => g.type === "create") && (
              <Button
                title="Add New Province"
                variant="success d-flex mt-2"
                onClick={() => {
                  handleOpenAddEditModal({});
                }}
                style={{ float: "right" }}
              >
                Add New Province
              </Button>
            )}
          </div>
        </div>

        <div className="table-responsive">
          <table
            ref={tableRef}
            className="table table-dark table-striped w-100"
          />

          <div className="constainer-fluid">
            <div className="d-flex justify-content-end">
              <div className="mx-4 py-2">
                <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
              </div>
              <BSPagination
                currentPage={pagination?.currentPage}
                totalPages={pagination?.totalPages}
                onPageChange={handlePageChange}
                siblingCount={2}
                showFirstLast={true}
              />
            </div>
          </div>
        </div>
      </div>
      {/* Add/Edit Modal */}
      <AddEditProvinceModal
        showModal={showAddEditModal}
        setShowModal={setShowAddEditModal}
        selectedProvince={selectedProvince}
        setSelectedProvince={setSelectedProvince}
        fetchProvinces={fetchProvinces}
        countriesList={countriesList}
      />
      {/* Details Modal */}
      <ProvinceDetails
        openDetailsModal={openDetailsModal}
        setOpenDetailsModal={setOpenDetailsModal}
        selectedProvince={selectedProvince}
        setSelectedProvince={setSelectedProvince}
      />
      <Modal
        show={showOptionsModal}
        onHide={handleCloseOptionsModal}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          <Button variant="secondary" onClick={handleCloseOptionsModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              modalOptions.method(modalOptions.data);
            }}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>

      <style>
        {`
.left-align {
  text-align: left !important;
}

        `}
      </style>
    </div>
  );
};

export default ProvinceList;
